__turbopack_context__.v({
  "Price": "D6i7JG_Price",
  "PromoRibbon": "D6i7JG_PromoRibbon",
  "PromoRibbon-retailer": "D6i7JG_PromoRibbon-retailer",
  "button-wrapper": "D6i7JG_button-wrapper",
  "dollar": "D6i7JG_dollar",
  "grid-item": "D6i7JG_grid-item",
  "instructional": "D6i7JG_instructional",
  "large-2": "D6i7JG_large-2",
  "large-3": "D6i7JG_large-3",
  "large-4": "D6i7JG_large-4",
  "promo-subheader": "D6i7JG_promo-subheader",
  "promo-title": "D6i7JG_promo-title",
  "promoItem": "D6i7JG_promoItem",
  "promos": "D6i7JG_promos",
});
